import React from 'react';

import styles from './Notification.module.scss';

const Notification = ({ org, altOrg, user, dot, item, date, onClick, text }) => {
  const handleImageError = (event) => {
    const image = event.target;
    image.src = altOrg;
  };

  return (
    <div
      className={styles.notificationContent}
      key={item.id}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={onClick}
    >
      <div className={styles.orgAvatarContainer}>
        <img src={org} alt="org avatar" className={styles.orgAvatar} onError={handleImageError} />
      </div>
      {user && (
        <div className={styles.subImageDiv}>
          <img src={user} alt="user avatar" className={styles.subImage} />
        </div>
      )}
      <div className={styles.notificationTextContainer}>
        <div className={item.read_at ? styles.notificationTextRead : styles.notificationTextNonRead}>
          <p>{text}</p>
        </div>
        <div className={styles.notificationTimeText}>
          <p>{date}</p>
        </div>
      </div>
      {!item.read_at && (
        <div>
          <img src={dot} alt="dot" className={styles.dotIcon} />
        </div>
      )}
    </div>
  );
};

export default Notification;
